import React, { useEffect, useState } from 'react';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { BaseTypography } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import ImageOrVideo from '../../components/common/ImageOrVideo/ImageOrVideo';
import { Grid } from '@material-ui/core';
import { getFullName } from '../../utils/helpers';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import backArrow from './back-arrow.png';

type PInterviewCarousel = {
    list: any;
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '60px 20px'
    },
    image:{
        maxWidth: '100% !important',
        '& iframe, video': {
            maxWidth: '100% !important',
          },
    },
	backimage:{
		width: '8px',
		height: 'auto',
		marginRight: '6px',
	},
    text: {
        margin: "20px 0 10px"
    },
    expertise: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    website:{
        margin: "20px 0 10px"
    },
	backlink: {
		color: '#0073C9',
		display: 'flex',
		alignItems: 'center',
		marginBottom: '15px',
	}
}));


export const Post: React.FC<PInterviewCarousel> = (props) => {
    const { list } = props;
    const commonClasses = useCommonStyles();
    const classes = useStyles();    

    useEffect(() => {
    }, [list])

    return (
        <div className={`${commonClasses.container} ${classes.root}`}>
            <Grid item xs={12} md={12}>
				<BaseTypography gutterBottom="true" color="primary"><a className={classes.backlink} href="/allposts?tab=blogposts" rel="noreferrer"><ImageOrVideo className={classes.backimage} src={backArrow} alt={list?.data.picture} width="100% !important"/> Back</a></BaseTypography>
                <BaseTypography gutterBottom="true" variant="h2">{list?.data?.blog_title}</BaseTypography>
                <BaseTypography gutterBottom="true" color="#555555" style={{ marginBottom: '20px' }}>Publish Date: {new Date(list?.data?.created_at).toDateString().split(" ").splice(1, 4).join(" ")}</BaseTypography>
                {list?.data?.picture && (
                    <ImageOrVideo className={classes.image} src={list?.data.picture} alt={list?.data.picture} width="100% !important"/>
                )}
                <BaseTypography className={classes.text} dangerouslySetInnerHTML={{ __html :list?.data.blog_description}} />
            </Grid>
        </div>
    )
}